import type { AUDIT_RUBRIC_VERSIONS } from '@/client/services/sessionAudit/constants'

export enum TutorAuditorLevel {
  Flagged = 'flagged',
  Novice = 'novice',
  Beginner = 'beginner',
  Intermediate = 'intermediate',
  Advanced = 'advanced',
}

export const AUDIT_RUBRIC_RESPONSES_LEVEL = [
  'level-1',
  'level-2',
  'level-3',
  'level-4',
  'level-0',
] as const
export type AuditRubricResponseLevel = (typeof AUDIT_RUBRIC_RESPONSES_LEVEL)[number]

export const AUDIT_RUBRIC_RESPONSES_YES_NO = ['no', 'yes'] as const
export type AuditRubricResponseYesNo = (typeof AUDIT_RUBRIC_RESPONSES_YES_NO)[number]

export type AuditRubricResponse = AuditRubricResponseLevel | AuditRubricResponseYesNo

export const AUDIT_REPLY_RATINGS = ['No', 'Somewhat', 'Yes'] as const
export type AuditReplyRating = (typeof AUDIT_REPLY_RATINGS)[number]

export type AuditReply = {
  rating: AuditReplyRating
  comment: string
  submittedAt: string
}

export enum AuditRating {
  None = 0,
  Flag = 1,
  Novice = 2,
  Proficient = 3,
  Advanced = 4,
}

export type AuditRubricQuestion =
  | {
      type: 'level'
      required: boolean
      slug: string
      label: string
      description: string
      responseDescriptions: Record<AuditRubricResponseLevel, string>
      defaultValue: AuditRubricResponseLevel
    }
  | {
      type: 'short-answer'
      required: boolean
      slug: string
      label: string
      sublabel?: string
      minLength: number
      defaultValue: string
    }
  | {
      type: 'yes-no'
      required: boolean
      slug: string
      label: string
      description: string
      responseDescriptions: Record<AuditRubricResponseYesNo, string>
      defaultValue: AuditRubricResponseYesNo
    }

export type AuditRubricQuestionType = AuditRubricQuestion['type']

export interface AuditRubricBlock {
  slug: string
  title: string
  questions: AuditRubricQuestion[]
}

export type AuditRubricVersion = (typeof AUDIT_RUBRIC_VERSIONS)[number]

export interface AuditRubricQuestions {
  version: AuditRubricVersion
  blocks: AuditRubricBlock[]
}

export interface AuditRubricResponses {
  version: AuditRubricVersion
  [key: string]: string | null
}

// This is now deprecated, but keeping around for old sessions.
export enum ItemResponse {
  Yes = 'yes',
  No = 'no',
  NotApplicable = 'not-applicable',
}

export type MarsDetails = {
  'mastery-1': ItemResponse
  'active-1': ItemResponse
  'active-2': ItemResponse
  'active-3': ItemResponse
  'respect-1': ItemResponse.Yes | ItemResponse.No
  'safety-1': ItemResponse.Yes | ItemResponse.No
  'mentor-1': ItemResponse.Yes | ItemResponse.No
}

export type MarsKey = keyof MarsDetails
